import React from "react"
import { Button } from "@/components/Button"

import { CancelButtonProps } from "@/components/Dialog/protocols"

export const CancelButton = (props: CancelButtonProps) => {
	return (
		<Button.Ghost
			onClick={props.onClick}
			size={props.size || "medium"}
		>
			{props.children}
		</Button.Ghost>
	)
}
